import { render } from "./ProjectStatusViewCard.vue?vue&type=template&id=f685bc70"
import script from "./ProjectStatusViewCard.vue?vue&type=script&lang=js"
export * from "./ProjectStatusViewCard.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__